import { render } from "./searchMs.vue?vue&type=template&id=20fdc45b"
import script from "./searchMs.vue?vue&type=script&lang=js"
export * from "./searchMs.vue?vue&type=script&lang=js"

import "./searchMs.vue?vue&type=style&index=0&id=20fdc45b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__